import SuccessIcon from "assets/icons/tick.svg";
import Button from "components/atoms/Button";
import { Box, Container, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { destroy } from "redux-form";
import { useAppDispatch } from "redux/hooks";
import {
  PARTNER_CHECKOUT_STORAGE_KEY,
  partnerHomePath,
  withPartnerToken,
} from "utils/partnerSession.util";

type PartnerPaymentSuccessProps = {
  bookingId: string;
};

export default function PartnerPaymentSuccess({ bookingId }: PartnerPaymentSuccessProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation("translation");

  useEffect(() => {
    localStorage.removeItem(PARTNER_CHECKOUT_STORAGE_KEY);
    localStorage.removeItem("classsPrice");
    localStorage.removeItem("classesPrices");
    localStorage.removeItem("SearchForm");
    localStorage.removeItem("SearchTripForm");
    localStorage.removeItem("SearchHourlyForm");
    localStorage.removeItem("AdditionalInfoForm");
    localStorage.removeItem("BookingFormPayload");
    localStorage.removeItem("PickUpForm");
    dispatch(destroy("SearchForm", "AdditionalInfoForm", "PickUpForm"));
  }, [dispatch]);

  const viewBooking = () => {
    navigate(withPartnerToken(`/booking/${bookingId}`));
  };

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 79px)",
        bgcolor: "#F2F2F7",
        display: "flex",
        alignItems: "center",
        py: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            bgcolor: "#ffffff",
            borderRadius: "20px",
            border: "1px solid #E4E3EB",
            boxShadow: "0px 12px 40px rgba(42, 52, 86, 0.08)",
            px: { xs: 3, sm: 5 },
            py: { xs: 4, sm: 5 },
            textAlign: "center",
          }}
        >
          <Stack spacing={3} alignItems="center">
            <Box
              sx={{
                width: 88,
                height: 88,
                borderRadius: "50%",
                bgcolor: "rgba(84, 214, 44, 0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={SuccessIcon} alt="" width={44} height={44} />
            </Box>

            <Stack spacing={1}>
              <Typography
                fontSize={{ xs: "20px", sm: "24px" }}
                fontWeight={700}
                color="#520A76"
                lineHeight={1.3}
              >
                {t("paymentSuccessful", "Payment successful")}
              </Typography>
              <Typography
                fontSize={{ xs: "14px", sm: "16px" }}
                fontWeight={400}
                color="#939399"
                lineHeight={1.5}
                maxWidth={360}
                mx="auto"
              >
                {t("YourBookingPlacedSuccessfully")}
              </Typography>
            </Stack>

            <Stack spacing={1.5} width="100%" mt={1}>
              <Button
                onClick={viewBooking}
                fullWidth
                variant="contained"
                color="info"
                sx={{
                  height: 52,
                  borderRadius: "12px",
                  fontSize: "15px",
                  fontWeight: 600,
                  textTransform: "none",
                }}
              >
                {t("viewBooking")}
              </Button>
              <Button
                onClick={() => navigate(partnerHomePath())}
                fullWidth
                variant="outlined"
                color="info"
                sx={{
                  height: 52,
                  borderRadius: "12px",
                  fontSize: "15px",
                  fontWeight: 600,
                  textTransform: "none",
                  borderColor: "#520A76",
                  color: "#520A76",
                  "&:hover": {
                    borderColor: "#3d0758",
                    bgcolor: "rgba(82, 10, 118, 0.04)",
                  },
                }}
              >
                {t("bookYourReturnRide")}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
